<template>
  <b-modal
    id="modalCreateTicket"
    centered
    title="Create Ticket"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
    <div class="mb-3">
      <label for="sale_ids" class="form-label">IDs das Vendas (separados por vírgula)</label>
      <b-form-input
        id="sale_ids"
        v-model="saleIdsInput"
        placeholder="Ex: 1487850, 1487851"
        type="text"
        :state="!errorsForm.sale_ids"
      />
      <b-form-invalid-feedback v-if="errorsForm.sale_ids">{{ errorsForm.sale_ids }}</b-form-invalid-feedback>
    </div>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="primary" @click="submitData">Criar Ticket</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import createTicketService from '@services/resources/createTicket';

const service = createTicketService.build();

export default {
  name: 'modalCreateTicket',
  data() {
    return {
      saleIdsInput: '',
      errorsForm: {},
    };
  },
  methods: {
    validateFields() {
      this.errorsForm = {};

      if (!this.saleIdsInput.trim()) {
        this.errorsForm.sale_ids = 'O campo IDs das vendas é obrigatório.';
        return false;
      }

      // Valida se todos os valores separados por vírgula são números válidos
      const ids = this.saleIdsInput.split(',').map(id => id.trim());
      const invalidIds = ids.filter(id => !id || isNaN(Number(id)));

      if (invalidIds.length > 0) {
        this.errorsForm.sale_ids = 'Informe apenas números separados por vírgula.';
        return false;
      }

      return true;
    },

    async submitData() {
      if (!this.validateFields()) return;

      try {
        const sale_ids = this.saleIdsInput.split(',').map(id => Number(id.trim()));

        await service.post('', { sale_ids });

        this.$bvToast.toast('Ticket criado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });

        this.$bvModal.hide('modalCreateTicket');
        this.resetForm();
      } catch (error) {
        let message = 'Erro ao enviar';

       if (
          error.response &&
          typeof error.response.data === 'string'
        ) {
          const parsed = JSON.parse(error.response.data);
          if (parsed.errors) {
            message = Object.values(parsed.errors).flat().join('\n');
          } else if (parsed.message) {
            message = parsed.message;
          }
        } else if (
          error.response &&
          typeof error.response.data === 'object' &&
          error.response.data.message
        ) {
          message = error.response.data.message;
        } else if (error.message) {
          message = error.message;
        }

        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      }
    },

    resetForm() {
      this.saleIdsInput = '';
      this.errorsForm = {};
    },
  },
};
</script>
